import React from 'react';
import ReactDOM from 'react-dom';
const mainDrawerPortal = document.getElementById('main-modal-portal');

export const MainModalPortal = ({ children }: any) => {
  return mainDrawerPortal
    ? ReactDOM.createPortal(
        children,
        mainDrawerPortal
    ) : <></>
}
